var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1421_1017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1421_1017",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7162 0.120117H0V23.8363H23.7162V0.120117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1421_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2964 0.120117H6.41974C2.87984 0.120117 0 2.99996 0 6.53986V17.4167C0 20.9564 2.87984 23.8362 6.41974 23.8362H17.2965C20.8363 23.8362 23.7161 20.9564 23.7161 17.4167V6.53986C23.7161 2.99996 20.8363 0.120117 17.2964 0.120117ZM22.3258 17.4167C22.3258 20.1897 20.0696 22.4458 17.2964 22.4458H6.41974C3.64649 22.4458 1.39036 20.1897 1.39036 17.4167V6.53986C1.39036 3.76661 3.64649 1.51048 6.41974 1.51048H17.2965C20.0696 1.51048 22.3258 3.76661 22.3258 6.53986V17.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8577 5.49442C8.28203 5.49442 5.37305 8.40335 5.37305 11.9792C5.37305 15.5549 8.28198 18.4638 11.8577 18.4638C15.4335 18.4638 18.3425 15.5549 18.3425 11.9792C18.3425 8.40335 15.4335 5.49442 11.8577 5.49442ZM11.8577 17.0735C9.04885 17.0735 6.76341 14.7882 6.76341 11.9792C6.76341 9.17027 9.04885 6.88477 11.8577 6.88477C14.6669 6.88477 16.9521 9.17027 16.9521 11.9792C16.9521 14.7882 14.6669 17.0735 11.8577 17.0735ZM18.4976 3.19141C17.4409 3.19141 16.5814 4.05107 16.5814 5.10755C16.5814 6.16426 17.4409 7.02388 18.4976 7.02388C19.5543 7.02388 20.4138 6.16426 20.4138 5.10759C20.4138 4.05093 19.5542 3.19141 18.4976 3.19141ZM18.4976 5.63338C18.2077 5.63338 17.9717 5.39742 17.9717 5.10755C17.9717 4.81754 18.2077 4.58176 18.4976 4.58176C18.7875 4.58176 19.0235 4.81754 19.0235 5.10755C19.0235 5.39742 18.7875 5.63338 18.4976 5.63338Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1421_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d7c9ab58aad7fd63316fb3eb91eaa640.svg";
export { ForwardRef as ReactComponent };